import AutoScrollPlugin from './AutoScrollPlugin';

export default AutoScrollPlugin;
